import React from 'react'
import {clientConfig} from '@modifi/client-config'
import {AdminNavigation} from '@modifi/ui'

const riskOfficeUrl = clientConfig.get('SERVICE_RISK_OFFICE')

const menuItems = [
  {
    label: 'Tasks',
    to: `${clientConfig.get('SERVICE_TASKS')}`,
    isExternal: true,
  },
  {
    label: 'Onboarding',
    to: clientConfig.get('SERVICE_ACTIVATIONS'),
    isExternal: true,
    subMenus: [
      {
        label: 'Companies',
        to: clientConfig.get('SERVICE_ACTIVATIONS'),
        isExternal: true,
      },
      {
        label: 'BSR list',
        to: `${clientConfig.get('SERVICE_ACTIVATIONS')}/bsr-list`,
        isExternal: true,
      },
    ],
  },
  {
    label: 'Customers',
    to: `${riskOfficeUrl}/companies`,
    isExternal: true,
  },
  {
    label: 'Orders',
    to: `${riskOfficeUrl}/orders`,
    isExternal: true,
  },
  {
    label: 'Payments',
    to: `${riskOfficeUrl}/funds-transfers`,
    isExternal: true,
  },
  {
    label: 'Billing',
    to: `${riskOfficeUrl}/invoices`,
    isExternal: true,
  },
  {
    label: 'Match',
    to: '/unmatched-transactions',
  },
]

const Header = () => (
  <AdminNavigation
    logoItem={{
      to: riskOfficeUrl,
      isExternal: true,
    }}
    menuItems={menuItems}
  />
)

export default Header
